export enum FileExtension {
  Unknown,
  Word,
  Excel,
  Powerpoint,
  Access,
  Text,
  Pdf,
  Xml,
  Music,
  Image,
  Video,
  Certificate,
  KeyFile
}
